module.exports = __webpack_public_path__ + "static/8-ceaed8b2633a95c7ebd36b3a64cf2d69.jpg";